<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0" v-if="center">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
            <div class="profile-info d-sm-flex align-items-center mb-10">
                <div class="m-0">
                    <!-- <h1 class="text-black fw-medium mb-8">{{ center.name }}</h1> -->
                    <span class="d-block text-dark-emphasis mb-0 small">
                        {{ center.id }}
                    </span>
                </div>
            </div>
            <!-- <div class="border-top mt-15 mb-15 mt-sm-20 mb-sm-20 mt-md-25 mb-md-25 mt-lg-30 mb-lg-30"></div> -->
            <div class="d-flex align-items-center justify-content-between">
                <h5 class="fw-medium text-black-emphasis mb-0"></h5>
                <router-link v-if="isAdmin" :to="{ path: `/center/${center.id}/edit` }"
                    class="d-inline-block text-decoration-none lh-1 text-muted fw-medium">
                    <i class="ph-duotone ph-pencil text-black position-relative top-1 fs-16 me-1"></i>
                    {{ $t('cta.edit') }}
                </router-link>
            </div>
            <ul class="info mt-25 ps-0 mb-0 list-unstyled">
                <li class="position-relative" v-if="center.department">
                    <div class="icon text-danger rounded-circle text-center">
                        <i class="ph ph-cube"></i>
                    </div>
                    <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.department.label') }}</span>
                    <span class="d-inline-block fs-md-15 fs-lg-16 text-muted">
                        {{ center.department }}
                    </span>
                </li>
                <li class="position-relative" v-if="center.main_contractor">
                    <div class="icon text-danger rounded-circle text-center">
                        <i class="ph ph-user"></i>
                    </div>
                    <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.main_contractor.label') }}</span>
                    <span class="d-inline-block fs-md-15 fs-lg-16 text-muted">
                        {{ center.main_contractor }}
                    </span>
                </li>
                <li class="position-relative" v-if="center.address || center.zip_code || center.country">
                    <div class="icon text-muted rounded-circle text-center">
                        <i class="ph ph-map-pin"></i>
                    </div>
                    <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.address.label') }}</span>
                    <span class="d-inline-block fs-md-15 fs-lg-16 text-muted">
                        {{ center.address }} - {{ center.zip_code }} - {{ center.country }}
                    </span>
                </li>
                <li class="position-relative" v-if="center.email">
                    <div class="icon text-success rounded-circle text-center">
                        <i class="ph ph-envelope-simple"></i>
                    </div>
                    <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.email.label') }}</span>
                    <a :href="`mailto:${center.email}`"
                        class="d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none">
                        {{ center.email }}
                    </a>
                </li>
                <li class="position-relative" v-if="center.phone">
                    <div class="icon text-warning-light rounded-circle text-center">
                        <i class="ph ph-phone"></i>
                    </div>
                    <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.phone.label') }}</span>
                    <a :href="`tel:${center.phone}`"
                        class="d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none">
                        {{ center.phone }}
                    </a>
                </li>
                <li class="position-relative" v-if="center.website">
                    <div class="icon text-info rounded-circle text-center">
                        <i class="ph ph-at"></i>
                    </div>
                    <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.website.label') }}</span>
                    <a :href="`https://${center.website}`" target="_blank"
                        class="d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none">
                        {{ center.website }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
  
<script lang="ts">
import { CenterInfo } from "@/utils/models/center.model";
import stateStore from "@/utils/store";
import { defineComponent } from "vue";

export default defineComponent({
    name: "CenterInfo",
    data() {
        return {
            center: this.$route.meta.center as CenterInfo
        }
    },
    computed: {
        isAdmin() { return stateStore.isAdmin() },
    },
});
</script>